import { SvgProps } from "../../types";

const Clock2 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#989DB7"}
      d="M6.999 13.75c-1.661 0-3.109-.55-4.342-1.652C1.423 10.996.716 9.62.535 7.972h1.48c.17 1.252.726 2.287 1.67 3.106.946.818 2.05 1.228 3.314 1.228 1.408 0 2.603-.491 3.584-1.472.981-.981 1.472-2.176 1.472-3.584s-.49-2.603-1.472-3.584C9.602 2.685 8.407 2.194 7 2.194c-.83 0-1.607.193-2.33.578a5.367 5.367 0 0 0-1.823 1.59h1.986v1.444H.5V1.472h1.444V3.17a6.306 6.306 0 0 1 2.248-1.787A6.45 6.45 0 0 1 7 .75c.903 0 1.748.172 2.537.515a6.607 6.607 0 0 1 2.058 1.39 6.606 6.606 0 0 1 1.39 2.058c.344.789.515 1.634.515 2.537s-.171 1.748-.515 2.537a6.606 6.606 0 0 1-1.39 2.058 6.606 6.606 0 0 1-2.058 1.39 6.288 6.288 0 0 1-2.537.515Zm2.022-3.467L6.277 7.54v-3.9H7.72V6.96l2.311 2.311-1.01 1.011Z"
    />
  </svg>
);
export default Clock2;
